// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5294":"css/app.6857","8669":"css/admin-app.6857"}[chunkId] + ".css";
};